<template>
	<Dialog ref="dialog"
		:confirmLabel="$t('text.confirm')"
		:cancelLabel="$t('text.cancel')"
		:confirm-handler="onConfirm"
		:cancel-handler="onCancel"
		:showClose="true"
		:title="$t('text.warning')"
		height="350px"
		width="550px"
	>
		<template #content>
			<v-row align="center" justify="center">
				<v-col cols="4" style="text-align:center">
					<v-icon size="80" color="#FDB537">mdi-alert-rhombus</v-icon>
				</v-col>
				<v-col cols="8" class="pr-5">
					<p v-html="$t('text.ticketOptionChangeInfo')" />
					<div class="mt-3">
						<p v-for="product of optionProducts" :key="product.id">- {{ product.title[serviceLocale] ?? product.title.de }}</p>
					</div>
				</v-col>
			</v-row>
		</template>
	</Dialog>
</template>

<script>
import Dialog from '@/components/common/Dialog.vue'

export default {
	components: { Dialog },
	props: {
		optionProducts: {
			type: Array,
			default: () => []
		},
		serviceLocale: {
			type: String,
			default: 'de'
		}
	},
	emits: ['confirm', 'cancel'],
	methods: {
		show() {
			this.$refs.dialog.show = true
		},
		hide() {
			this.$refs.dialog.show = false
		},
		onConfirm() {
			this.$refs.dialog.show = false
			this.$emit('confirm')
		},
		onCancel() {
			this.$emit('cancel')
		}
	}
}
</script>
